export function normalizeTaskCommentBody(body: string) {
  return body.replace(/\\r\\n|\\n|\\r/g, '\n')
}
